import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  useTheme
} from '@mui/material';

export default function RenameDialog({
  open,
  onClose,
  zipfile,
  onSave,
  loading = false
}) {
  const theme = useTheme();
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  // Reset form when dialog opens with new zipfile
  useEffect(() => {
    if (open && zipfile) {
      setName(zipfile.name || '');
      setError('');
    }
  }, [open, zipfile]);

  const handleSave = () => {
    // Validate name
    const trimmedName = name.trim();

    if (!trimmedName) {
      setError('Archive name is required');
      return;
    }

    if (trimmedName === zipfile.name) {
      // No change, just close
      onClose();
      return;
    }

    // Call save with the new name
    onSave(zipfile.id_, trimmedName);
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 0  // Match app style
        }
      }}
    >
      <DialogTitle sx={{ fontSize: theme.typography.fontSize.lg }}>
        Rename Archive
      </DialogTitle>

      <DialogContent sx={{ pt: theme.spacing(2) }}>
        <TextField
          autoFocus
          fullWidth
          label="Archive Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setError(''); // Clear error on change
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && !loading) {
              handleSave();
            }
          }}
          error={!!error}
          helperText={error}
          disabled={loading}
          sx={{ mb: theme.spacing(1) }}
        />
      </DialogContent>

      <DialogActions sx={{ p: theme.spacing(2), pt: 0 }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          sx={{ minWidth: theme.spacing(10) }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading || !name.trim()}
          sx={{ minWidth: theme.spacing(10) }}
        >
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}